export default [
  {
    title: 'Dashboard',
    acl: ['Super'],
    to: { name: 'super' },
    icon: { icon: 'tabler-dashboard' },
  },
  {
    heading: 'Business Management',
    acl: ['Super'],
  },
  {
    title: 'Businesses',
    acl: ['Super'],
    to: { name: 'super-businesses' },
    icon: { icon: 'tabler-building-store' },
  },
  {
    title: 'Statements',
    acl: ['Super'],
    to: { name: 'super-statements' },
    icon: { icon: 'tabler-receipt' },
  },
  {
    title: 'Adjustments',
    acl: ['Super'],
    to: { name: 'super-adjustments' },
    icon: { icon: 'tabler-adjustments' },
  },
  {
    title: 'Gift Cards',
    acl: ['Super'],
    to: { name: 'super-gift-cards' },
    icon: { icon: 'tabler-gift' },
  },
  {
    title: 'Campaign Moderation',
    acl: ['Super'],
    to: { name: 'super-campaigns' },
    icon: { icon: 'tabler-mail-check' },
  },
  {
    heading: 'Remote Support',
    acl: ['Super'],
  },
  {
    title: 'RustDesk',
    acl: ['Super'],
    to: { name: 'super-rustdesk' },
    icon: { icon: 'tabler-device-desktop-analytics' },
  },
  {
    heading: 'Administration',
    acl: ['Super'],
  },
  {
    title: 'Super Staff',
    acl: ['Super'],
    to: { name: 'super-staff' },
    icon: { icon: 'tabler-user-shield' },
  },
]
